import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteFormat',
  standalone: true
})
export class ByteFormatPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    let currentValue = value;
    if (currentValue < 1024) {
      return `${currentValue} B`;
    }

    currentValue /= 1024;
    if (currentValue < 1024) {
      return `${currentValue.toFixed(2)} KB`;
    }

    currentValue /= 1024;
    if (currentValue < 1024) {
      return `${currentValue.toFixed(2)} MB`;
    }

    currentValue /= 1024;
    return `${currentValue.toFixed(2)} GB`;
  }

}
